// attendanceStatistics.js
// 考勤统计配置管理 API

import request from '@/utils/request'

// 查询考勤统计配置列表
export function listClockInStatistics(data) {
  return request({
    url: 'OA/clockInStatisticsConfig/list',
    method: 'get',
    params: data,
  })
}

// 查询考勤统计配置详情
export function getClockInStatistics(id) {
  return request({
    url: 'OA/clockInStatisticsConfig',
    method: 'get',
    params: { id },
  })
}

// 新增考勤统计配置
export function addClockInStatistics(data) {
  return request({
    url: 'OA/clockInStatisticsConfig',
    method: 'post',
    data: data,
  })
}

// 修改考勤统计配置
export function updateClockInStatistics(data) {
  return request({
    url: 'OA/clockInStatisticsConfig',
    method: 'put',
    data: data,
  })
}

// 删除考勤统计配置
export function delClockInStatistics(data) {
  return request({
    url: 'OA/clockInStatisticsConfig',
    method: 'delete',
    params: data,
  })
}
export function  clockInStatisticsDateBatch(data) {
  return request({
    url: 'OA/clockInStatisticsDate/batch',
    method: 'post',
    data: data,
  })
}

export function  clockInStatisticsDatelist(data) {
  return request({
    url: 'OA/clockInStatisticsDate/list',
    method: 'get',
    params: data,
  })
}
export function  clockInStatisticsDatedelete(data) {
  return request({
    url: 'OA/clockInStatisticsDate',
    method: 'delete',
    params: data,
  })
}